import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.initializeObserver()
    }

    disconnect() {
        if (this.boundCheckVisibility) {
            window.removeEventListener('scroll', this.boundCheckVisibility)
        }
    }

    initializeObserver() {
        // Set initial state for paragraphs
        this.element.querySelectorAll('p').forEach(p => {
            p.classList.add('opacity-30', 'transition-opacity', 'duration-700')
        })

        // Add smooth transition to the SkinSort icon
        const icon = this.element.querySelector('.skinsort-icon')
        if (icon) {
            icon.classList.add('transition-all', 'duration-700', 'ease-out')
        }

        // Bind the scroll handler to maintain context
        this.boundCheckVisibility = this.checkVisibility.bind(this)

        window.addEventListener('scroll', this.boundCheckVisibility)
        this.checkVisibility() // Check initial state
    }

    checkVisibility() {
        const viewportMiddle = window.innerHeight / 2

        this.element.querySelectorAll('p').forEach(p => {
            const rect = p.getBoundingClientRect()
            const elementTop = rect.top

            if (elementTop <= viewportMiddle && elementTop >= -rect.height) {
                p.classList.remove('opacity-30')
                p.classList.add('opacity-100')

                // Check if this paragraph contains the SkinSort icon
                const icon = p.querySelector('.skinsort-icon')
                if (icon) {
                    icon.classList.remove('rotate-12')
                    icon.classList.add('rotate-3', 'scale-125')
                }
            }
        })
    }
} 